export default __webpack_public_path__ + "static/media/sortByIcon.db1a9f0d.svg";